(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initializePilotGallery(root) {
    if (!root || root.dataset.pilotGalleryReady === 'true') return;

    var video = root.querySelector('[data-pilot-video]');
    var image = root.querySelector('[data-pilot-image]');
    var label = root.querySelector('[data-pilot-label]');
    var buttons = root.querySelectorAll('[data-pilot-media]');
    var previous = root.querySelector('[data-pilot-previous]');
    var next = root.querySelector('[data-pilot-next]');
    var title = root.querySelector('[data-pilot-title]');
    var description = root.querySelector('[data-pilot-description]');
    var count = root.querySelector('[data-pilot-count]');

    if (!video || !image || !buttons.length || !previous || !next) return;

    root.dataset.pilotGalleryReady = 'true';

    function selectMedia(index) {
      var normalizedIndex = (index + buttons.length) % buttons.length;
      var button = buttons[normalizedIndex];

      buttons.forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
      if (title) title.textContent = button.dataset.title || '';
      if (description) description.textContent = button.dataset.description || '';
      if (count) count.textContent = String(normalizedIndex + 1).padStart(2, '0') + ' / ' + String(buttons.length).padStart(2, '0');

      if (button.dataset.kind === 'video') {
        image.hidden = true;
        video.hidden = false;
        label.hidden = false;
        root.dispatchEvent(new CustomEvent('product-media:change', { detail: { videoActive: true } }));
        return;
      }

      video.pause();
      video.hidden = true;
      label.hidden = true;
      root.dispatchEvent(new CustomEvent('product-media:change', { detail: { videoActive: false } }));
      image.src = button.dataset.src;
      image.alt = button.dataset.alt || '';
      image.hidden = false;
    }

    function activeIndex() {
      var active = root.querySelector('[data-pilot-media][aria-pressed="true"]');
      return Math.max(0, Array.prototype.indexOf.call(buttons, active));
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        selectMedia(index);
      });
    });

    previous.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      selectMedia(activeIndex() - 1);
    });

    next.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      selectMedia(activeIndex() + 1);
    });

    root.addEventListener('keydown', function (event) {
      if (event.target === video) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        selectMedia(activeIndex() - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        selectMedia(activeIndex() + 1);
      }
    });
    selectMedia(activeIndex());
  }

  function initializePilotGalleries(container) {
    (container || document).querySelectorAll('[data-pilot-gallery]').forEach(initializePilotGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializePilotGalleries(document);
    });
  } else {
    initializePilotGalleries(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializePilotGalleries(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
